import { DEFAULT_COLUMN_WIDTH, getDefaultColumnWidth } from "@common-models/task-column";
import { getColumnValues } from "@common-reducers/TaskSelectors";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { Box, Stack } from "@mui/material";
import { memo } from "react";
import { CellFooterProps } from "../cell-interface";
import BatterySumCell from "./battery-sum-cell";
import CheckboxSumCell from "./checkbox-sum-cell";
import FilesSumCell from "./files-sum-cell";
import NumberSumCell from "./number-sum-cell";
import PersonPickerSumCell from "./personpicker-sum-cell";
import RatingSumCell from "./rating-sum-cell";




function ColumnFooterCell({
    groupId,
    columnId,
    boardId,
    columnType,
    customData,
    column,
    index
}: CellFooterProps) {

    const footerCell = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#013750",
        fontWeight: "400",
        fontSize: "15px",
        height: "39px",
        boxSizing: "border-box"
    }
    const values = useAppSelector((state) => getColumnValues(state, { groupId: groupId, columnId: columnId, boardId: boardId, columnType: columnType }))
    return (
        <Box
            key={index}
            className={`column_${columnId}`}
            sx={{
                ...footerCell,
                width: column.width ?? getDefaultColumnWidth(column.type),
                borderRight: '2px solid transparent',
                transition: 'width 0.05s',
            }}
        >
            <Stack direction="row" alignItems={"center"} flexGrow={1} textAlign={"center"}
                sx={{ background: 'var(--color-surface)', width: "100%", height: "100%", overflow: "hidden", textOverflow: "ellipsis" }} >
                {columnType === "number" ?
                    (<NumberSumCell columnId={columnId} values={(values as number[]) ?? []} />) : null}


                {columnType === "status-option-picker" || columnType === "option-picker" || columnType === "complexity-picker" ?

                    (<BatterySumCell values={values as { selectedOptionsCloned: unknown[]; tasksLength: number }} />) : null}
                {columnType === "files" ?

                    (<FilesSumCell values={(values as unknown[]) ?? []} columnId={columnId} groupId={groupId ?? null} />) : null}

                {columnType === "checkbox" ?

                    (<CheckboxSumCell values={values as { length: number; data: unknown[] }} columnId={columnId} />) : null}
                {columnType === "rating" ?

                    (<RatingSumCell values={values as { length: number; data: unknown[] }} columnId={columnId} />) : null}
                {columnType === "person-picker" ?
                    (<PersonPickerSumCell values={(values as unknown[]) ?? []} boardId={boardId?.toString() ?? ""} />) : null}

            </Stack>
        </Box>
    );
}


export default memo(ColumnFooterCell)